import { format } from 'date-fns';
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { parseResumeDate } from '../../utils/formatDate';

const MyMonthInput = ({ value, onChange, min, disabled, className }) => {
  const selectedDate = parseResumeDate(value);
  const minimumDate = min
    ? (min instanceof Date ? min : new Date(min))
    : null;

  const handleDateChange = (date) => {
    if (date) {
      const isoDate = format(date, 'yyyy-MM') + '-01';
      onChange({ target: { value: isoDate } });
    } else {
      onChange({ target: { value: '' } });
    }
  };

  return (
    <DatePicker
      selected={selectedDate}
      onChange={handleDateChange}
      showMonthYearPicker
      dateFormat="MM/yyyy"
      minDate={minimumDate}
      disabled={disabled}
      className={`${className} ${disabled ? 'disabled-input' : ''}`}
    />
  );
};


export default MyMonthInput;
